import { disposeModal, showModal } from "@/App/utils/showBootstrapModal";
import GeneralModal from "@/Pages/Cases/components/CaseList/GeneralModal.vue";
import { mountModal } from "@/App/components/Dispatch/mountModal";

export const showGeneralModal = (modalId: string, title: string, text: string, onConfirm: () => void) => {
  const onDispose = () => disposeModal({ modalId });

  mountModal(GeneralModal, {
    modalId,
    modalTitle: title,
    modalText: text,
    onClose: onDispose,
    onCancel: () => {},
    onConfirm,
  });

  showModal({ modalId });
};
